import { render, staticRenderFns } from "./UserInformationPanel.vue?vue&type=template&id=1de09f6b&scoped=true&"
import script from "./UserInformationPanel.vue?vue&type=script&lang=js&"
export * from "./UserInformationPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserInformationPanel.vue?vue&type=style&index=0&id=1de09f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de09f6b",
  null
  
)

export default component.exports